
export const handleFormatAmount = (amount : string) => {
    return Number(amount.replace(/,/g, ""));
};